module.exports = __webpack_public_path__ + "img/Alonso_Tovar.e26e27d9.webp";